/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * CTA style.
 */
export let CTA_STYLE;

/**
 * CTA type.
 */
(function (CTA_STYLE) {
  CTA_STYLE["TEXT"] = "text";
  CTA_STYLE["BUTTON"] = "button";
  CTA_STYLE["CARD"] = "card";
  CTA_STYLE["CARDLINK"] = "card-link";
  CTA_STYLE["FEATURE"] = "feature";
})(CTA_STYLE || (CTA_STYLE = {}));
export let CTA_TYPE;
(function (CTA_TYPE) {
  CTA_TYPE["REGULAR"] = "";
  CTA_TYPE["LOCAL"] = "local";
  CTA_TYPE["JUMP"] = "jump";
  CTA_TYPE["EXTERNAL"] = "external";
  CTA_TYPE["NEW_TAB"] = "new tab";
  CTA_TYPE["DOWNLOAD"] = "download";
  CTA_TYPE["VIDEO"] = "video";
  CTA_TYPE["PDF"] = "pdf";
  CTA_TYPE["BLOG"] = "blog";
  CTA_TYPE["EMAIL"] = "email";
  CTA_TYPE["SCHEDULE"] = "schedule";
  CTA_TYPE["CHAT"] = "chat";
  CTA_TYPE["CALL"] = "call";
})(CTA_TYPE || (CTA_TYPE = {}));
//# sourceMappingURL=defs.js.map
